import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Contact from '../components/contact';
import ContactForm from '../components/contactform';
import Googlemap from '../components/googlemap';

const ContactUs = () => {
  return (
    <div className="contact-us-page" style={{ backgroundColor: '#f1f5fc' }}>
      <Container>
        {/* Agar Contact component mein already form+map hain to use ek section me */}
        <Row className="mb-5">
          <Col>
            <Contact />
          </Col>
        </Row>

        {/* Agar ContactForm aur Googlemap separately bhi show karna hai to */}
        <Row className="align-items-center">
          <Col xs={12} lg={6} className="mb-4 mb-lg-0">
            <ContactForm />
          </Col>
          <Col xs={12} lg={6}>
            <Googlemap />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ContactUs;
